module.exports = __webpack_public_path__ + "static/media/google_play.e2745812.svg";